import { useQuery } from '@tanstack/react-query';
import { ACCEPTED_TOPICS } from '../data/accepted-topics';
import { API_ENDPOINTS } from '../config/api-config';
import axios from '../utils/axios-config';

export function useTopics(slug) {
  // Get all topics
  const getAllTopics = useQuery({
    queryKey: ['topics'],
    queryFn: async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.TOPICS.GET_ALL);
        return response.data;
      } catch (error) {
        // Fall back to accepted topics if API fails
        return ACCEPTED_TOPICS;
      }
    },
  });

  // Get topic by slug
  const getTopicBySlug = useQuery({
    queryKey: ['topic', slug],
    queryFn: async () => {
      try {
        const response = await axios.get(
          API_ENDPOINTS.TOPICS.GET_BY_SLUG(slug)
        );
        return response.data;
      } catch (error) {
        // Fall back to local data if API fails
        return ACCEPTED_TOPICS.find((topic) => topic.slug === slug) || null;
      }
    },
    enabled: !!slug,
  });

  return {
    data: getAllTopics.data || [],
    isLoading: getAllTopics.isLoading,
    error: getAllTopics.error,
    getAllTopics,
    getTopicBySlug,
  };
}
